import { render, staticRenderFns } from "./nouveautes.vue?vue&type=template&id=4b207c54&scoped=true&"
import script from "./nouveautes.vue?vue&type=script&lang=ts&"
export * from "./nouveautes.vue?vue&type=script&lang=ts&"
import style0 from "./nouveautes.vue?vue&type=style&index=0&id=4b207c54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b207c54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VAlert,VBtn,VCard,VCardActions,VCardText,VCardTitle})
